const MOCK_TOKENS = {
  exchange: {
    data: {
      accessToken: 'mock-access-token-eyJhbGciOiJSUzI1NiJ9.eyJzdWIiOiJtb2NrLXVzZXJAbW9jay5ydSIsImV4cCI6OTk5OTk5OTk5OX0',
      idToken: 'mock-id-token-eyJhbGciOiJSUzI1NiJ9.eyJzdWIiOiJtb2NrLXVzZXJAbW9jay5ydSIsIm5hbWUiOiJNb2NrIFVzZXIifQ',
      expiresIn: 3600,
      tokenType: 'Bearer',
    },
  },
  refresh: {
    data: {
      accessToken:
        'mock-refreshed-access-token-eyJhbGciOiJSUzI1NiJ9.eyJzdWIiOiJtb2NrLXVzZXJAbW9jay5ydSIsImV4cCI6OTk5OTk5OTk5OX0',
      idToken: null,
      expiresIn: 3600,
      tokenType: 'Bearer',
    },
  },
};

const REFRESH_FAIL_PROBABILITY = 0.7;

export default {
  exchange() {
    return Promise.resolve(MOCK_TOKENS.exchange);
  },

  refresh() {
    if (Math.random() < REFRESH_FAIL_PROBABILITY) {
      return Promise.reject(
        Object.assign(new Error('Mock refresh token expired'), {
          response: { status: 401, data: { error: 'mock_refresh_failed' } },
        }),
      );
    }
    return Promise.resolve(MOCK_TOKENS.refresh);
  },
};
